// extracted by mini-css-extract-plugin
export default {"content_page":"byggetida1992_content_page__n-3y2","grid":"byggetida1992_grid__2lnxF","grid_obj":"byggetida1992_grid_obj__y2XF-","img_container":"byggetida1992_img_container__NbHze"};